import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithSessionEnd } from './common'
import { CreateValueResponse } from 'types/ApiResponse'

const VALUE = '/value'

export const valueApi = createApi({
  reducerPath: 'valueApi',
  refetchOnMountOrArgChange: true,
  baseQuery: baseQueryWithSessionEnd,

  endpoints: (builder) => ({
    createValue: builder.query<CreateValueResponse, { id: number }>({
      query: (args) => ({
        url: `${VALUE}/${args.id}`,
        method: 'GET',
      }),
    }),
    getValueDocument: builder.query<Blob, { id: number }>({
      query: (args) => ({
        url: `${VALUE}/${args.id}/document`,
        method: 'GET',
        responseHandler: (response: any) => {
          return response.blob()
        },
      }),
    }),
  }),
})

export const { useLazyCreateValueQuery, useLazyGetValueDocumentQuery } = valueApi
